import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import BusinessAvatar from './BusinessAvatar'

type Props = {
  name: string
  category?: string
  coverImageUrl?: string | null
  portraitImageUrl?: string | null
  logoImageUrl?: string | null
  href: string
  badge?: string | null
  meta?: string | null
  actionLabel?: string | null
  onAction?: (() => void) | null
}

export default function BusinessPageCard({
  name,
  category,
  coverImageUrl,
  portraitImageUrl,
  logoImageUrl,
  href,
  badge = null,
  meta = null,
  actionLabel = null,
  onAction = null,
}: Props) {
  const [loaded, setLoaded] = useState(false)
  return (
    <Link to={href} className="group relative block overflow-hidden rounded-xl transition-transform duration-200 ease-out will-change-transform hover:scale-[1.015] hover:shadow-lg hover:shadow-black/30">
      <div className="aspect-[8/9] bg-white/5">
        {coverImageUrl || portraitImageUrl ? (
          <img
            src={coverImageUrl || portraitImageUrl || ''}
            alt={name}
            loading="lazy"
            onLoad={() => setLoaded(true)}
            className={`h-full w-full object-cover transition-all duration-500 ${loaded ? 'opacity-100 blur-0 scale-100' : 'opacity-80 blur-sm scale-[1.02]'}`}
          />
        ) : null}
      </div>

      {badge ? (
        <span className="absolute right-2 top-2 rounded-full border border-white/20 bg-black/65 px-2 py-0.5 text-[10px] font-semibold tracking-wide text-white shadow">
          {badge}
        </span>
      ) : null}

      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/65 via-black/25 to-transparent p-3">
        <div className="flex items-end gap-2">
          <BusinessAvatar name={name} logoImageUrl={logoImageUrl} size={34} className="shadow-lg" />
          <div className="min-w-0">
            <div className="line-clamp-1 text-sm font-semibold text-white">{name}</div>
            {category ? <div className="line-clamp-1 text-xs text-white/85">{category}</div> : null}
            {meta ? <div className="line-clamp-1 text-[11px] text-white/75">{meta}</div> : null}
          </div>
        </div>
        {actionLabel && onAction ? (
          <div className="mt-2">
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault()
                e.stopPropagation()
                onAction()
              }}
              className="rounded-full border border-brand/40 bg-brand/20 px-3 py-1 text-[11px] font-semibold text-brand-100 hover:bg-brand/30"
            >
              {actionLabel}
            </button>
          </div>
        ) : null}
      </div>
    </Link>
  )
}
